import styles from './FanaticalPopup.module.css'
import { useTranslations } from "next-intl";
import LinkButton, { LinkButtonKind, LinkButtonSize } from "../Buttons/LinkButton/LinkButton";
import Button, { ButtonSize } from "../Buttons/Button/Button";
import FanaticalLogo from "@/assets/img/Image_Fanatical.png"
import Image from 'next/image';
//TODO: Type game
export default function FanaticalPopup({ game, onClose }: { game: any, onClose: () => void }) {

    const t = useTranslations("Modals.Fanatical")

    return (
        <div className={styles.main} data-testid="FanaticalPopup">
            <Image src={FanaticalLogo} alt={'fanatical'} data-testid="FanaticalPopup_logo"/>
            <h2 data-testid="FanaticalPopup_title">{t('title')}</h2>
            <div className={styles.buttons} data-testid="FanaticalPopup_buttons">
                <LinkButton size={LinkButtonSize.LARGE} internal={false} target='_blank' data-testid="FanaticalPopup_purchaseLink" kind={LinkButtonKind.SUGGESTED} href={game.purchase_link}>{t('buyButton')}</LinkButton>
                <Button size={ButtonSize.LARGE} onClick={onClose} data-testid="FanaticalPopup_closeButton">{t('playButton')}</Button>
            </div>
            <div className={styles.list} data-testid="FanaticalPopup_list">
                <p className={styles.title}>{t('listTitle')}</p>
                <ol>
                    <li>{t('list_1')}</li>
                    <li>{t('list_2')}</li>
                    <li>{t('list_3')}</li>
                </ol>
            </div>
        </div>
    )

}